<div class="data-import-wrapper">
  <mat-error *ngIf="hasError">
    {{ errorMessage }}
  </mat-error>
</div>
